import React, { useState, useEffect } from "react";
import { FaRegSave, FaTimes } from "react-icons/fa";
import { GoPencil } from "react-icons/go";
import AddDesignatedModal from "../AddDesignatedModal/AddDesignatedModal";

const ViewEditEvent = ({ show, onClose, event, onSave, onDelete }) => {
  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
  };

  const priorityOptions = [
    { value: "high", label: "Alta" },
    { value: "medium", label: "Média" },
    { value: "low", label: "Baixa" },
  ];

  const typeOptions = [
    { value: "meeting", label: "Reunião" },
    { value: "holiday", label: "Feriado" },
    { value: "deadline", label: "Prazo" },
  ];

  const priorityColors = {
    high: "#dc3545",
    medium: "#ffc107",
    low: "#28a745",
  };

  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [type, setType] = useState("");
  const [priority, setPriority] = useState("");
  const [designados, setDesignados] = useState([]);
  const [showDesignadosModal, setShowDesignadosModal] = useState(false);

  useEffect(() => {
    if (event) {
      setTitle(event.title || "Título do Evento");
      setDate(event.start ? new Date(event.start).toISOString().slice(0, 16) : "");
      setType(event.extendedProps?.type || "meeting");
      setPriority(event.extendedProps?.priority || "medium");
      setDesignados(event.extendedProps?.designados || []);
    }
  }, [event]);

  const userList = [
    { id: "1", name: "João", avatar: "https://via.placeholder.com/40" },
    { id: "2", name: "Maria", avatar: "https://via.placeholder.com/40" },
    { id: "3", name: "Carlos", avatar: "https://via.placeholder.com/40" },
  ];

  const handleSave = () => {
    const updatedEvent = {
      ...event,
      title,
      start: date,
      extendedProps: {
        ...(event.extendedProps || {}),
        type,
        priority,
        designados,
      },
    };
    onSave(updatedEvent);
    setIsEditing(false);
  };

  const handleRemoveDesignado = (index) => {
    const updated = [...designados];
    updated.splice(index, 1);
    setDesignados(updated);
  };

  if (!show) return null;
  if (!event) return <div className="text-white p-4">Evento não encontrado.</div>;

  const getOptionLabel = (options, value) =>
    options.find((o) => o.value === value)?.label || value;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={onClose}
      ></div>

      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{ backgroundColor: "#17296B", color: "white", borderRadius: "10px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header d-flex justify-content-between align-items-start border-0 pb-0">
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    width: "4px",
                    height: "24px",
                    backgroundColor: "#0d6efd",
                    borderRadius: "2px",
                  }}
                ></div>
                <h1 className="modal-title fs-5 mb-0 text-white">
                  {isEditing ? "Editar Evento" : "Detalhes do Evento"}
                </h1>
              </div>
              <div>
                <button
                  type="button"
                  className="btn text-light mx-2 mb-3"
                  onClick={isEditing ? handleSave : () => setIsEditing(true)}
                  style={{ backgroundColor: "#1B0F5B" }}
                >
                  {isEditing ? (
                    <>
                      <FaRegSave className="me-1" />
                      Guardar
                    </>
                  ) : (
                    <>
                      <GoPencil className="me-1" />
                      Editar
                    </>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={onClose}
                  style={{ backgroundColor: "#1B0F5B", border: "none" }}
                >
                  <FaTimes />
                </button>
              </div>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label text-white">Título</label>
                {isEditing ? (
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="form-control"
                  />
                ) : (
                  <div className="text-white">{title}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label text-white">Data</label>
                {isEditing ? (
                  <input
                    type="datetime-local"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="form-control"
                  />
                ) : (
                  <div className="text-white">{formatDateTime(date)}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label text-white">Tipo</label>
                {isEditing ? (
                  <select
                    className="form-select"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    {typeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="text-white">{getOptionLabel(typeOptions, type)}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label text-white">Prioridade</label>
                {isEditing ? (
                  <select
                    className="form-select"
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                  >
                    {priorityOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div
                    className="text-white"
                    style={{ color: priorityColors[priority], fontWeight: "bold" }}
                  >
                    {getOptionLabel(priorityOptions, priority)}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label text-white">Designados</label>
                <div className="d-flex flex-wrap gap-2">
                  {designados.map((designado, index) => (
                    <div key={designado.id} className="d-flex align-items-center gap-2">
                      <img
                        src={designado.avatar}
                        alt={`Avatar de ${designado.name}`}
                        className="rounded-circle"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          border: "2px solid white",
                        }}
                      />
                      <span className="text-white">{designado.name}</span>
                      {isEditing && (
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveDesignado(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                </div>
                {isEditing && (
                  <button
                    className="btn btn-sm btn-outline-light mt-2"
                    onClick={() => setShowDesignadosModal(true)}
                  >
                    + Adicionar Designados
                  </button>
                )}
              </div>

              {isEditing && (
                <div className="d-flex justify-content-end mt-3">
                  <button className="btn btn-danger" onClick={() => onDelete(event)}>
                    Apagar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddDesignatedModal
        show={showDesignadosModal}
        onClose={() => setShowDesignadosModal(false)}
        userList={userList}
        onSave={(selecionados) => {
          setDesignados(selecionados);
          setShowDesignadosModal(false);
        }}
        selectedDesignados={designados}
      />
    </>
  );
};

export default ViewEditEvent;
